import { userStatus } from "../../../../../constants/user";

export const formatAge = (age: string = "0-0-0") => {
  const [years = 0, months = 0, days = 0] = `${age}`?.split("-").map(Number);
  if (years > 0 && months > 0 && days > 0) {
    return `${years} years, ${months} months, and ${days} days`;
  } else if (years > 0 && months > 0 && days === 0) {
    return `${years} years and ${months} months`;
  } else if (years > 0 && months === 0 && days > 0) {
    return `${years} years and ${days} days`;
  } else if (years > 0 && months === 0 && days === 0) {
    return `${years} years`;
  } else if (years === 0 && months > 0 && days > 0) {
    return `${months} months and ${days} days`;
  } else if (years === 0 && months > 0 && days === 0) {
    return `${months} months`;
  } else if (years === 0 && months === 0 && days >= 0) {
    return `${days} days`;
  } else {
    return "Invalid age format";
  }
};

export const formatCurrency = (amount: number) => {
  return amount?.toLocaleString("en-IN", {
    maximumFractionDigits: 2,
    style: "currency",
    currency: "INR",
  }) || "";
};

export const ESTIMATE_APPROVAL_ARRAY = [
  userStatus.APPROVED,
  userStatus.FOLLOW_UP_ONE,
  userStatus.FOLLOW_UP_THREE,
  userStatus.FOLLOW_UP_SEVEN,
  userStatus.FOLLOW_UP_FIFTEEN,
]